import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Close as CloseIcon, ContentCopy as CopyIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import PaymentDetailsModal from "./bankdetails";

const BankDetailsModal = ({ open, onClose, orderId,price }) => {
  console.log("Received Order ID prop:", orderId);

  const [successMessage, setSuccessMessage] = useState("");
  const [bankDetails, setBankDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [formData, setFormData] = useState({
    depositorName: "",
    amountPaid: "",
    bankPaidFrom: "",
    paidFromAccountNumber: "",
    phoneNumber: "",
    date: "",
  });
// eslint-disable-next-line
  const theme = useTheme();
  const isDesktop = useMediaQuery("(min-width: 768px)");


  useEffect(() => {
    console.log("Received Order ID prop:", orderId);
  }, [orderId]);
  
  useEffect(() => {
    if (!open) return;

    const fetchBankDetails = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          "https://daradservice.azurewebsites.net/api/P2PProducts/get-bank",
          {
            headers: {
              Accept: "text/plain",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch bank details");
        }

        const data = await response.json();
        setBankDetails(data);
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setBankDetails(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBankDetails();
  }, [open]);
  useEffect(() => {
    if (orderId) {
      console.log("Retrieved Order ID:", orderId);
    }
  }, [orderId]);
  
  

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Account number copied!");
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isDesktop ? 800 : "90vw",
            maxWidth: "600px",
            bgcolor: "#fff",
            p: isDesktop ? 3 : 2,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: "center",
          }}
        >
          <Box display="flex" justifyContent="end">
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Typography
            sx={{
              fontSize: isDesktop ? "28px" : "20px",
              color: "#5604F6",
              fontWeight: "bold",
            }}
          >
            Bank Details
          </Typography>
          <Typography sx={{ fontSize: isDesktop ? "18px" : "14px", color: "#000" }}>
  Please copy the account details below to make payment, total Amount to Pay is ₦
  {new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 }).format(price || 0)}
</Typography>

         
          {loading ? (
            <CircularProgress sx={{ color: "#5604F6", my: 2 }} />
          ) : bankDetails && bankDetails.data.length > 0 ? (
            <Box mt={3}>
              {[
                { label: "Bank Name", value: bankDetails.data[0].bankName },
                { label: "Account Name", value: bankDetails.data[0].accountName },
                { label: "Account Number", value: bankDetails.data[0].accountNumber },
              ].map(({ label, value }, index) => (
                <Box key={index} sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                  <Typography sx={{ fontSize: isDesktop ? "18px" : "14px" }}>{label}:</Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography sx={{ fontSize: isDesktop ? "18px" : "14px", color: "#5604F6", fontWeight: "800" }}>
  {value}
</Typography>

                    {label === "Account Number" && (
                      <IconButton onClick={() => copyToClipboard(value)} size="small">
                        <CopyIcon sx={{ fontSize: "18px", color: "#5604F6" }} />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography color="error" mt={2}>
              Failed to load bank details.
            </Typography>
          )}

          <Button
            sx={{
              mt: 3,
              backgroundColor: "#5604F6",
              color: "white",
              borderRadius: "9999px",
              padding: "10px 24px",
              width: "100%",
              maxWidth: "300px",
            }}
            onClick={() => {
              setShowPaymentModal(true);
              onClose();
            }}
          >
            I Have Paid
          </Button>
        </Box>
      </Modal>

      <PaymentDetailsModal
        open={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        orderId={orderId}
        formData={formData}
        setFormData={setFormData}
      />
    </>
  );
};

export default BankDetailsModal;